import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchStoreById } from "../../../../redux/Thunk/Store/StoreThunks";
import { setStoreById } from "../../../../redux/Reducer/Store/StoreSlice";
import CheckedBg from "../../../common/icons/CheckedBg";
import Close from "../../../common/icons/Close";
import Timing from "../../../common/icons/Timing";
import ArrowDown from "../../../common/icons/ArrowDown";
import toast from "react-hot-toast";
import { useOutsideClick } from "../../../common/useOutsideClick";

const SearchSelectStore = (props) => {
  const {
    stores = [],
    setSelectedStore = () => {}, // Default to an empty function to prevent errors
    selectedStore = null,
    setFieldValue = () => {},
  } = props;
  // const { setFieldValue, values } = formik;
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dispatch = useDispatch();
  //   const dropdownStoreRef = useRef(null);

  const filteredStores = stores?.filter((store) =>
    store?.title?.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const store = useSelector((state) => state.store?.storeById);

  const handleClickOutside = (event) => {
    if (
      dropdownStoreRef?.current &&
      !dropdownStoreRef?.current?.contains(event?.target)
    ) {
      setIsOpen(false);
    }
  };
  const dropdownStoreRef = useOutsideClick(handleClickOutside);

  useEffect(() => {
    if (!Object.keys(store).length) {
      setSelectedStore("");
    } else {
      setSelectedStore(store);
    }
  }, [store, setSelectedStore]);

  const handleToggleDropdown = () => {
    setIsOpen((prev) => {
      const newState = !prev;
      if (!newState) return newState; // If closing, no need to focus
      setTimeout(() => {
        const input = document.getElementById("search");
        input?.focus();
      }, 0);
      return newState;
    });
  };

  const handleSelectStore = async (store) => {
    setSelectedStore(store);

    const response = await dispatch(
      fetchStoreById({ storeId: store?.SID })
    ).unwrap();
    if (response?.status === 200 || response?.status === 201) {
      setFieldValue("storeDetails.SID", store?.SID);
    } else {
      toast.error(response?.message);
    }

    setIsOpen(false);
  };
  const handleClearSearch = (e) => {
    dispatch(setStoreById({}));
    e.stopPropagation();
    setSelectedStore("");
    setIsOpen(false);
  };

  return (
    <div className="relative" onClick={(e) => e.stopPropagation()}>
      <div
        ref={dropdownStoreRef}
        onClick={handleToggleDropdown}
        className="flex items-center justify-between p-4 bg-gray-100 w-full text-gray-700 border border-gray-300 rounded-[10px] cursor-pointer"
      >
        {Object?.keys(selectedStore)?.length > 0 ? (
          <div className="flex items-center gap-3">
            <div className="w-[20px] h-[20px]">
              {selectedStore?.currentStoreStatus ? (
                selectedStore?.currentStoreStatus === "ACTIVE" ? (
                  <CheckedBg fill="#00C732" />
                ) : selectedStore?.currentStoreStatus === "CLOSED" ? (
                  <Close />
                ) : selectedStore?.currentStoreStatus === "AWAY" ? (
                  <Timing />
                ) : null
              ) : null}
            </div>
            <div className="w-[calc(100%_-_30px)]">
              <div className="font-medium text-base text-gray-800">
                {selectedStore?.title}
              </div>
              <div className="text-sm text-gray-500">
                #{selectedStore?.SID} • {selectedStore?.address?.areaRoad},{" "}
                {selectedStore?.address?.city}
              </div>
            </div>
          </div>
        ) : (
          "Search or Select Store"
        )}
        {!Object?.keys(selectedStore)?.length > 0 && (
          <button className="ml-2 text-gray-500 hover:text-gray-700 focus:outline-none">
            <ArrowDown />
          </button>
        )}
        {Object?.keys(selectedStore)?.length > 0 && (
          <button
            onClick={handleClearSearch}
            className="ml-2 text-gray-500 hover:text-gray-700 focus:outline-none"
          >
            <svg
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              className="w-4 h-4"
            >
              <path d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        )}
      </div>
      {isOpen && (
        <div className="z-[99] absolute w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg z-50">
          <input
            id="search"
            type="text"
            placeholder="Search store..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value.trimStart())}
            className="w-full p-2 border-b border-gray-300 focus:outline-none rounded-t-md"
          />

          <ul className="max-h-[450px] overflow-y-auto">
            {filteredStores?.length > 0 ? (
              filteredStores?.map((store) => (
                <li
                  key={store?.SID}
                  onClick={() => handleSelectStore(store)}
                  className="p-4 cursor-pointer hover:bg-gray-100"
                >
                  <div className="flex items-center gap-3">
                    <div className="w-[20px] h-[20px]">
                      {store?.currentStoreStatus ? (
                        store?.currentStoreStatus === "ACTIVE" ? (
                          <CheckedBg fill="#00C732" />
                        ) : store?.currentStoreStatus === "CLOSED" ? (
                          <Close />
                        ) : store?.currentStoreStatus === "AWAY" ? (
                          <Timing />
                        ) : null
                      ) : null}
                    </div>
                    <div className="w-[calc(100%_-_30px)]">
                      <div className="font-medium text-base text-gray-800">
                        {store?.title}
                      </div>
                      <div className="text-sm text-gray-500">
                        #{store?.SID} • {store?.address?.areaRoad},{" "}
                        {store?.address?.city}
                      </div>
                    </div>
                  </div>
                </li>
              ))
            ) : (
              <li className="p-4 text-gray-500">No stores found</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SearchSelectStore;
